import { queryOptions } from '@tanstack/react-query';
import type { TenantConfig } from '@meeting-assistant/schemas';
import { getTenantConfig } from '@/lib/api';

export const tenantConfigQueryOptions = queryOptions<TenantConfig>({
  queryKey: ['tenantConfig'],
  queryFn: getTenantConfig,
  staleTime: Infinity,
});
